// This file is part of sisdai-proyecto-base.
//
//   sisdai-proyecto-base is free software: you can redistribute it and/or modify
//   it under the terms of the GNU Lesser General Public License as published by the
//   Free Software Foundation, either version 3 of the License, or
//   (at your option) any later version.
//
//   sisdai-proyecto-base is distributed in the hope that it will be useful,
//   but WITHOUT ANY WARRANTY; without even the implied warranty of
//   MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General
//   Public License for more details.
//
//   You should have received a copy of the GNU Lesser General Public License along
//   with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: () => import('@/views/PaginaInicio.vue'),
  },
  {
    path: '/glosario',
    name: 'Glosario',
    component: () => import('@/views/Glosario.vue'),
  },
  {
    path: '/creditos',
    name: 'Creditos',
    component: () => import('@/views/Creditos.vue'),
  },
  {
    path: '/creditos/:id',
    name: 'Investigadores',
    component: () => import('@/views/Investigadorxs.vue'),
    props: true,
  },
  {
    path: '/balance',
    name: 'Introduccion',
    component: () => import('@/views/Balance/Introduccion.vue'),
  },
  {
    path: '/balance/produccion',
    name: 'Producción',
    component: () => import('@/views/Balance/Produccion.vue'),
  },
  {
    path: '/balance/comercio-exterior',
    name: 'Comercio exterior',
    component: () => import('@/views/Balance/ComercioExterior.vue'),
  },
  {
    path: '/balance/transformaciones',
    name: 'Transformaciones principales',
    component: () => import('@/views/Balance/Transformaciones.vue'),
  },
  {
    path: '/balance/consumo-final',
    name: 'Consumo final',
    component: () => import('@/views/Balance/ConsumoFinal.vue'),
  },
  {
    path: '/balance/balance-energia',
    name: 'Balance de energía',
    component: () => import('@/views/Balance/BalanceEnergia.vue'),
  },
  {
    path: '/hidrocarburos',
    name: 'Hidrocarburos',
    component: () => import('@/views/Hidrocarburos/Hidrocarburos.vue'),
  },
  {
    path: '/hidrocarburos/historia',
    name: 'HistoriaHidrocarburos',
    component: () => import('@/views/Hidrocarburos/HistoriaHidrocarburos.vue'),
  },
  {
    path: '/hidrocarburos/demanda',
    name: 'DemandaHidrocarburos',
    component: () => import('@/views/Hidrocarburos/Demanda.vue'),
  },
  {
    path: '/hidrocarburos/reservas-crudo',
    name: 'ReservasCrudo',
    component: () => import('@/views/Hidrocarburos/ReservasCrudo.vue'),
  },
  {
    path: '/hidrocarburos/reservas-gas',
    name: 'ReservasGas',
    component: () => import('@/views/Hidrocarburos/ReservasGas.vue'),
  },
  {
    path: '/hidrocarburos/produccion-crudo',
    name: 'ProduccionCrudo',
    component: () => import('@/views/Hidrocarburos/ProduccionCrudo.vue'),
  },
  {
    path: '/hidrocarburos/produccion-gas',
    name: 'ProduccionGas',
    component: () => import('@/views/Hidrocarburos/ProduccionGas.vue'),
  },
  {
    path: '/hidrocarburos/flujo-gas',
    name: 'FlujoGas',
    component: () => import('@/views/Hidrocarburos/FlujoGas.vue'),
  },
  {
    path: '/hidrocarburos/refinacion-distribucion',
    name: 'Infraestructura',
    component: () => import('@/views/Hidrocarburos/Infraestructura.vue'),
  },
  {
    path: '/electricidad',
    name: 'Electricidad',
    component: () => import('@/views/Electricidad/Electricidad.vue'),
  },
  {
    path: '/electricidad/sistema-electrico-nacional',
    name: 'Sistema Electrico',
    component: () => import('@/views/Electricidad/SistemaElectrico.vue'),
  },
  {
    path: '/electricidad/capacidad-generacion',
    name: 'Capacidad y generación',
    component: () => import('@/views/Electricidad/CapacidadGeneracion.vue'),
  },
  {
    path: '/electricidad/factor-planta',
    name: 'Factor de planta',
    component: () => import('@/views/Electricidad/FactorPlanta.vue'),
  },
  {
    path: '/electricidad/consumo',
    name: 'Consumo',
    component: () => import('@/views/Electricidad/Consumo.vue'),
  },
  {
    path: '/electricidad/transmision',
    name: 'Transmisión',
    component: () => import('@/views/Electricidad/Transmision.vue'),
  },
  {
    path: '/electricidad/ocupacion-territorial',
    name: 'Ocupación territorial y factor de planta',
    component: () => import('@/views/Electricidad/OcupacionTerritorial.vue'),
  },
  {
    path: '/electricidad/balance',
    name: 'Balance de electricidad',
    component: () => import('@/views/Electricidad/BalanceElectricidad.vue'),
  },
  {
    path: '/electricidad/acceso',
    name: 'Acceso',
    component: () => import('@/views/Electricidad/Acceso.vue'),
  },
  {
    path: '/electricidad/relacion-socioeconomica',
    name: 'Relación socio-económica',
    component: () => import('@/views/Electricidad/RelacionSocioeconomica.vue'),
  },
  {
    path: '/biomasa',
    name: 'Biomasa',
    component: () => import('@/views/Biomasa/Biomasa.vue'),
  },
  {
    path: '/biomasa/estado-actual',
    name: 'BiomasaEstadoActual',
    component: () => import('@/views/Biomasa/EstadoActual.vue'),
  },
  {
    path: '/biomasa/demanda',
    name: 'BiomasaDemanda',
    component: () => import('@/views/Biomasa/Demanda.vue'),
  },
  {
    path: '/biomasa/oferta',
    name: 'BiomasaOferta',
    component: () => import('@/views/Biomasa/Oferta.vue'),
  },
  {
    path: '/biomasa/balance',
    name: 'BiomasaBalanceOfertaDemanda',
    component: () => import('@/views/Biomasa/Balance.vue'),
  },
  {
    path: '**',
    name: 'pagina-no-encontrada',
    component: () => import('@/views/ErrorPaginaNoEncontrada.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0, behavior: 'smooth' }
  },
})

// Muestra el título de la página dependiendo de las vistas
router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} | ${to.name}`
  next()
})

export default router
